<template>
  <div class="amp_main">
    <div class="addbg_main">
      <div class="flex_bet_h tools_titmod">
        <span class="tools_tit">加背景音</span>
        <img
          src="../../assets/images/img2/offlogin.png"
          class="tools_off"
          @click="hide"
        />
      </div>
      <div class="tools_top add_sle" @click="show_audiosel = true">
        <div v-if="workinfo.musicpath">
          <p>{{ workinfo.wkname }}</p>
        </div>
        <div v-else>
          <img
            src="../../assets/images/img2/joint_add.png"
            class="tools_addfile"
          />
          <p>选择作品</p>
        </div>
      </div>
      <p class="add_tit2">选择音频</p>
      <div class="tools_top add_sle" @click="show_bgmusic = true">
        <p v-if="bg_music.bgid">{{ bg_music.bgname }}</p>
        <div v-else>
          <img
            src="../../assets/images/img2/joint_add.png"
            class="tools_addfile"
          />
          <p>选择背景音</p>
        </div>
      </div>
      <!-- <div class="add_install">
        <div class="add_install_sli">
          <p class="add_install_tit">原生音量</p>
          <el-slider v-model="work_volume"></el-slider>
        </div>
        <span class="add_install_num">10</span>
      </div> -->
      <div class="add_install">
        <div class="add_install_sli">
          <p class="add_install_tit">背景音量</p>
          <el-slider v-model="bg_volume" :min="0" :max="100"></el-slider>
        </div>
        <span class="add_install_num">{{ bg_volume }}</span>
      </div>
      <div class="add_install">
        <div class="add_install_sli">
          <p class="add_install_tit">原声播报延迟</p>
          <el-slider v-model="work_time" :min="0" :max="10"></el-slider>
        </div>
        <span class="add_install_num">{{ work_time }}</span>
      </div>
      <div class="add_install">
        <div class="add_install_sli">
          <p class="add_install_tit">背景音乐续播</p>
          <el-slider v-model="bg_time" :min="0" :max="10"></el-slider>
        </div>
        <span class="add_install_num">{{ bg_time }}</span>
      </div>
      <div class="flex_bet_h">
        <div class="tools_btn tools_btn3" @click="fusionBgMusicForTts(false)" v-if="!play_state">
          <img src="../../assets/images/play.png" class="tools_btn_icon" />
          <span>试听效果</span>
        </div>
        <div class="tools_btn tools_btn3" @click="stopPlay" v-else>
          <img src="../../assets/images/play.png" class="tools_btn_icon" />
          <span>暂停播放</span>
        </div>
        <div
          class="tools_btn tools_btn2 tools_btn3"
          @click="fusionBgMusicForTts(true)"
        >
          <img
            src="../../assets/images/img2/exfile.png"
            class="tools_btn_icon"
          />
          <span>导出音频</span>
        </div>
      </div>
    </div>
    <div style="margin-left: 24px">
      <!-- 选择音频组件 -->
      <AudioSelect
        v-if="show_audiosel"
        @overSelect="addAudioList"
        :ismore="false"
      />
    </div>
    <!-- 添加音乐弹框 -->
    <Bgdmusic v-model="show_bgmusic" @selectBgmusic="selectBgmusic"></Bgdmusic>
  </div>
</template>
<script>
// 作品选择组件
import AudioSelect from "./audio_select.vue";
//背景音乐组件
import Bgdmusic from "../../components/bgdmusic.vue";
export default {
  components: {
    AudioSelect,
    Bgdmusic,
  },
  data() {
    return {
      work_volume: 50, //原生音量
      bg_volume: 50, //背景音量
      work_time: 0, //原声播报延迟时间
      bg_time: 0, //背景音乐续播时间
      show_audiosel: false, //作品选择组件
      workinfo: {}, //选择的作品信息
      show_bgmusic: false, //背景音乐选择组件显示状态
      bg_music: {}, //选择的背景音乐
      synurl: "", //合成后音频地址
      audio: new Audio(), //播放器
      play_state: false, //播放状态
      time: null,
    };
  },
  methods: {
    // 停止播放
    stopPlay() {
      this.audio.pause();
      this.play_state = false;
    },
    // 监听播放状态
    monitorPlay() {
      let self = this;
      this.time = setInterval(() => {
        if (self.audio.ended) {
          self.play_state = false;
          clearInterval(self.time);
        }
      }, 1000);
    },
    // 选择背景音乐
    selectBgmusic(e) {
      console.log(e);
      this.show_bgmusic = false;
      this.bg_music = e;
    },
    addAudioList(e) {
      console.log(e);
      this.show_audiosel = false;
      if (e.length > 0) this.workinfo = e[0];
    },
    // 背景音混音
    fusionBgMusicForTts(isextend) {
      // isextend？true=导出音频：false=试听效果
      console.log(this.workinfo.feature)
      if (isextend && this.$store.state.userrich.isvalidsvip !== "1" && this.$store.state.userrich.isvalidvip !== "1") {
        this.$globalFun.goToOpenVip(
          this,
          "开通超级会员无限制使用工具，是否前往开通会员。"
        );
        return;
      }
      if(isextend && this.$store.state.userrich.isvalidsvip !== "1" && this.workinfo.feature === "1"){
        this.$globalFun.goToOpenVip(
          this,
          "该作品主播为金牌主播需开通超级会员，是否前往开通会员。"
        );
        return
      }
      if (!this.workinfo.musicpath) {
        this.$message({
          message: "请选择作品",
          type: "warning",
        });
        return;
      }
      if (!this.bg_music.bgid) {
        this.$message({
          message: "请选择背景音乐",
          type: "warning",
        });
        return;
      }
      let self = this;
      let json = {
        mp3url: this.workinfo.musicpath,
        bgid: this.bg_music.bgid,
        bgdelaytime: this.bg_time,
        textdelaytime: this.work_time,
        bgvolume: this.bg_volume,
      };
      let url =
        self.$store.state.app_api + self.$store.state.app_url.ttsmixbgmapp;
      const loading = this.$loading({
        lock: true,
        text: "背景音合成中...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
      self.$request.postHttp(json, url, (response) => {
        loading.close();
        self.synurl = response.model.mp3url;
        if (!isextend) {
          self.audio.src = self.synurl;
          self.audio.play();
          self.play_state = true;
          self.monitorPlay();
        } else {
          this.$globalFun.downloadDub(self.synurl);
        }
      });
    },
    hide() {
      this.$emit("hide");
    },
  },
};
</script>

<style>
@import url("../../assets/css/tools.css");
</style>


// WEBPACK FOOTER //
// src/components/tools/add_bgmusci.vue